import { TableCell, TableRow } from "@mui/material";

export default function InfoRow(props) {
    const { colSpan } = props
    return <TableRow><TableCell colSpan={colSpan} align="center" style={{ border: "none", height: "300px", color: "grey" }}>
        {props.children}
    </TableCell></TableRow>
}